export const PLOT_PREVIEW_MINIMUM = 5000;

export function legacyPreviewRequest(result: any) {
  const step = String(result?.artifactStep || result?.currentStep || "").toLowerCase().replace(/[ _-]+/g, " ").trim();
  const steps: Record<string, string> = {
    "quality control": "qc", qc: "qc", normalization: "normalization",
    "feature selection": "feature_selection", umap: "umap", clustering: "clustering",
    "cell type annotation": "cell_type_annotation", trajectory: "trajectory",
    "trajectory analysis": "trajectory", "gene expression": "gene_expression",
  };
  let artifact = result?.artifactId || result?.qcArtifactId || result?.qcMeta?.qcArtifactId;
  if (artifact && typeof artifact === "object") {
    artifact = artifact.artifact_id || artifact.artifactId || artifact.qcArtifactId || artifact.id;
  }
  const total = Number(result?.totalGenes ?? result?.totalCells ?? result?.nGenes ?? 0);
  const sample = Number(result?.sampleN ?? 0);
  if (!steps[step] || !artifact || sample <= 0 || sample >= (total > 0 ? Math.min(PLOT_PREVIEW_MINIMUM, total) : PLOT_PREVIEW_MINIMUM)) return null;
  return { step: steps[step], artifactId: String(artifact),
    seed: Number(result?.sampleSeed ?? 0), sample_n: PLOT_PREVIEW_MINIMUM,
    selectedGene: result?.selectedGene };
}

export function mergeRefreshedPreview(result: any, preview: any) {
  const updated = { ...result, ...preview, currentStep: result.currentStep };
  if (preview.totalGenes != null) delete updated.totalCells;
  for (const key of ["qcMeta", "normalizationMeta", "umapMeta", "clusteringMeta", "annotationMeta", "trajectoryMeta"]) {
    if (result[key]) updated[key] = { ...result[key], sampleN: preview.sampleN, sampleSeed: preview.sampleSeed };
  }
  // UMAP must use the newly sampled columns rather than an older row cache.
  delete updated.umapData;
  return updated;
}
